module.exports = __webpack_public_path__ + "static/media/securityRemovedItem.2b6da04e.svg";